import { all, call } from "redux-saga/effects";
import { watchDeleteDataMenuRoles, watchGetDataMenuRoles, watchSetDataMenuRoles } from "./menuRoleSaga";
import { watchGetDataMenuAll, watchSetDataMenu } from "./menuSaga";
import { watchGetDataRolesAll } from "./roleSaga";
//IndexImportHygen
export default function* rootMenuRoleSaga() {
    yield all([
        call(watchGetDataMenuAll),
        call(watchGetDataRolesAll),
        call(watchGetDataMenuRoles),
        call(watchSetDataMenuRoles),
        call(watchDeleteDataMenuRoles),
        call(watchSetDataMenu),
        //IndexUsingHygen
    ])
}